import { Component, inject, OnInit, signal } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { TranslationService } from '../../../shared/i18n/translation.service';

@Component({
  selector: 'app-partenaires',
  templateUrl: './partenaires.html',
  styleUrl: './partenaires.scss',
})
export class PartenairesComponent implements OnInit {
  private readonly api = inject(ApiService);
  readonly i18n = inject(TranslationService);
  readonly partners = signal<any[]>([]);
  ngOnInit(): void { this.api.getPartners().subscribe({ next: rows => this.partners.set(rows) }); }
  byCategory(category: 'france' | 'cameroon' | 'other' | 'church'): any[] { return this.partners().filter(partner => (partner.country ?? 'other') === category); }
  description(item: any): string { return item[`full_name_${this.i18n.language()}`] || item.full_name_fr || ''; }
  address(item: any): string { return item[`address_${this.i18n.language()}`] || item.address_fr || ''; }
  mediaUrl(value: unknown): string {
    const url = String(value ?? '').trim();
    if (!url) return '';
    if (/^www\./i.test(url)) return `https://${url}`;
    if (/^http:\/\//i.test(url)) return url.replace(/^http:\/\//i, 'https://');
    return url;
  }
  hideBrokenImage(event: Event): void { (event.target as HTMLImageElement).style.display = 'none'; }
  fallback(fr: string, en: string): string { return this.i18n.language() === 'en' ? en : fr; }
}
